<template>
  <div class="expert-score">
    <div class="container-fluid">
      <div class="wrapper">
        <div class="content-page">
          <div class="content">
            <div class="row mb-1">
              <div class="col-xl-6">区域管理</div>
              <div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;">
                <Breadcrumb></Breadcrumb>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="mb-2">
                  <span>区域：</span>
                  <el-cascader :options="areaOptions" :props="{expandTrigger: 'hover', checkStrictly: true, label: 'name', value: 'id' }" clearable filterable @change="cascaderChange">
                    <template slot-scope="{ node, data }">
                      <span>{{ data.name }}</span>
                      <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                    </template>
                  </el-cascader>
                  <el-button class="ml-2 mr-2" type="success" @click="getData">查询</el-button>
                  <el-button type="primary" style="font-size:17px"  icon="el-icon-edit" @click="toUpdate(false,'add')">新建区域</el-button>
                </div>
                <el-table v-loading="loading" :data="list" :header-cell-style="tableHeaderStyle" border>
                  <el-table-column label="区域名称" min-width="200">
                    <template slot-scope="scope">
                      <template v-if="scope.row.parentRegionName">
                        <span>{{scope.row.parentRegionName}} </span>
                        <i class="el-icon-right"></i>
                      </template>
                      {{ scope.row.regionName }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="regionNnm" label="区域内单位数量" min-width="120">
                  </el-table-column>
                  <!--  show-overflow-tooltip  -->
                  <el-table-column prop="userNum" label="区域内用户数量"></el-table-column>
                  <el-table-column prop="preliminaryExaminer" label="初审员" min-width="120">
                  </el-table-column>
                  <el-table-column label="操作" width="160">
                    <template slot-scope="scope">
                      <el-button size="small" type="primary"  @click="toUpdate(scope.row, 'update')">修改</el-button>
                      <el-button size="small" type="danger"  @click="toUpdate(scope.row, 'del')">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 分页器 -->
                <div class="text-right mt-2">
                  <el-pagination background layout="total, prev, pager, next" :page-size="query.pageSize" :total="total" @current-change="handlePageChange"></el-pagination>
                </div>
                <el-dialog :title="isAdd?'添加区域信息':'修改区域信息'" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
                  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="right">
                    <el-form-item label="上级区域名称:" prop="nikeName">
                      <el-cascader v-model="cascaderModel" :options="areaOptions" :props="{ expandTrigger: 'hover', checkStrictly: true, label: 'name', value: 'id'}" clearable filterable @change="(e)=>{cascaderChange(e,'form')}">
                        <template slot-scope="{ node, data }">
                          <span>{{ data.name }}</span>
                          <span v-if="!node.isLeaf">({{ data.children.length }}) </span>
                        </template>
                      </el-cascader>
                    </el-form-item>
                    <el-form-item label="区域名称:" prop="regionName">
                      <el-input v-model="ruleForm.regionName"></el-input>
                    </el-form-item>
                    <el-form-item class="flex_end_x">
                      <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                      <el-button @click="dialogFormVisible = false">返回</el-button>
                    </el-form-item>
                  </el-form>
                </el-dialog>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAreaList,
  getAreaDetail,
  getAreaTree,
  deleteArea,
  addArea,
  updateArea,
} from "@/api/after/systemManagement";
import Breadcrumb from "@/views/backstage/components/Breadcrumb.vue";
export default {
  name: "areaManagement",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      tableHeaderStyle: {
        backgroundColor: "#3083c5",
        color: "#fff",
      },
      cascaderModel: [], //表单上级区域默认值
      dialogFormVisible: false,
      list: [],
      areaOptions: [],
      columnVal: null,
      query: {
        pageNumber: 1,
        pageSize: 10,
        pageSorts: [{ asc: true, column: "" }],
        id: null,
      },
      total: 0,
      ruleForm: {
        regionName: "",
        name1: "",
      },
      rules: {
        name1: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      isAdd: true, //是否添加状态
      loading: false
    };
  },
  mounted() {
    this.getData();
    this.getAreaTree();
  },
  methods: {
    // 获取数据列表
    getData() {
      this.loading = true
      getAreaList(this.query).then((res) => {
        if (res.code == 200) {
          this.list = res.data.records;
          this.total = res.data.total;
          this.loading = false 
        } else {
          this.$message.error(res.data);
        }
      });
    },
    // 获取详情信息
    getDetail(id) {
      getAreaDetail(id).then((res) => {
        if (res.code == 200) {
          this.ruleForm = res.data;
          console.log(this.ruleForm);
          if (res.data.parentId) {
            this.cascaderModel = res.data.parentIds.reverse();
          }
          this.dialogFormVisible = true;
        } else {
          this.$message.error(res.data);
        }
      });
    },
    getAreaTree() {
      getAreaTree().then((res) => {
        if (res.code == 200) {
          this.areaOptions = res.data;
        } else {
          this.$message.error(res.data);
        }
      });
    },
    //区域查询
    cascaderChange(e, name) {
      let num = 0;
      e.length <= 0 ? (num = 0) : (num = e[e.length - 1]);
      if (name == "form") {
        this.ruleForm.parentId = num;
      } else {
        this.query.id = num;
      }
    },
    toUpdate(data, name) {
      this.cascaderModel = [];
      if (name == "del") {
        if (data.regionNnm > 0) {
          this.$message.warning("该区域下有单位，不能删除");
          return;
        }
        this.$confirm("确定要将该区域删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error",
        }).then(() => {
          this.deleteData(data.id);
        });
      } else if (name == "update") {
        this.isAdd = false;
        this.getDetail(data.id);
      } else if (name == "add") {
        this.isAdd = true;
        this.ruleForm = {
          parentId: 0,
          regionName: "",
        };
        this.dialogFormVisible = true;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isAdd ? this.addData() : this.updateData();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除
    deleteData(id) {
      deleteArea(id).then((res) => {
        if (res.code == 200) {
          this.$message.success("删除成功");
        } else {
          this.$message.error(res.data);
        }
        this.getData();
        this.getAreaTree();
      });
    },
    // 添加
    addData() {
      addArea(this.ruleForm).then((res) => {
        if (res.code == 200) {
          this.$message.success("添加成功");
        } else {
          this.$message.error(res.data);
        }
        this.dialogFormVisible = false;
        this.getData();
        this.getAreaTree();
      });
    },
    //修改
    updateData() {
      updateArea(this.ruleForm).then((res) => {
        if (res.code == 200) {
          this.$message.success("修改成功");
        } else {
          this.$message.error(res.data);
        }
        this.dialogFormVisible = false;
        this.getData();
        this.getAreaTree();
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.query.pageNumber = val;
      this.getData();
    },
  },
};
</script>
<style scoped>
.wrap {
  background: #fafbfe;
  padding: 30px;
}
.con {
  min-height: 500px;
  background: #fff;
  padding: 30px;
  border-radius: 5px;
}
/deep/.el-table th > .cell {
  text-align: center;
}

/deep/.el-table .cell {
  text-align: center;
}
</style>